import React, { useContext } from "react";
import { AppProvider } from "../provider";
import { ProductLayout } from "./product/layout";

/**
 * @visibleName
 */
export default function RootContainer() {
  return (
    <AppProvider>
      <ProductLayout />
    </AppProvider>
  );
}
